import colors from "../../Library/colors"

export default [
  {
    name: "Africa",
    places:
      "Botswana, Ethiopia, Kenya, Madagascar, Malawi, Mauritius, Morocco, Mozambique, Namibia, Rwanda, Seychelles, South Africa, Tanzania, Uganda, Zambia, Zimbabwe",
    slug: "africa",
    image: require("../../Library/Images/destinations/africa/giraffe.png"),
    imagePath: "destinations/africa/giraffe.png",
    darkenImage: 0.2,
    description:
      "The breadth and scope of diversity in Africa requires a number of specialists. Aside from the individual country differences the safari options are also abundant, and it is essential to have a knowledgeable and trustworthy resource. The specialists I work with have often lived and worked in their regions of expertise and each have a deep love of Africa which translates to the service they provide. Whether it is a self-drive safari in Namibia, a tour of the souks in Fez or a gorilla trek you will be connected to a true expert.",
    informations: [
      {
        title: "DINE",
        location: "IKOYI, LONDON",
        content:
          "For some regional west African cooking try Iyoki which has opened in London's Westend. Ex-Noma chef and his childhood mate are firing up a storm with fermented chilis, plantain and smoky peppercorns in a neighborhood more familiar with shepherd's pie.",
        imageUrl: require("../../Library/Images/destinations/africa/lamp.jpg"),
        frameColor: colors.red,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
      {
        title: "RELAX",
        location: "SPA FARNATCHI, MARRAKECH",
        content:
          "For a hammam treatment which will leave you floating on air visit the Farnatchi Spa, adjoining a riad hotel in a quiet part of the Medina. It is elegant and serene from the moment you arrive and greeted with herbal tea before being shown to a tiled changing room outside your private hammam. After a period in the steamy low-lit room a salt scrub is applied and rinsed off with cool water. A massage from Ahmed is the icing on the cake.",
        imageUrl: require("../../Library/Images/destinations/africa/spa.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "left"],
        inverted: false,
      },
      {
        title: "CAMP",
        location: "SERENGETI SAFARI CAMP, TANZANIA",
        content:
          "For a real sense of the bush, Nomad safaris set up a mobile camp in different parts of the Serengeti to track the migration throughout the year. Comfort and good food are not compromised. Sitting round the campfire with a pre-dinner drink and listening to the animal sounds bring you much closer to wildlife than staying in a permanent lodge.",
        imageUrl: require("../../Library/Images/destinations/africa/camp.jpg"),
        frameColor: colors.red,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
    ],
  },
  {
    name: "Asia",
    places: "Bhutan, Burma, Cambodia, India, Indonesia, Japan, Laos, Malaysia, Nepal, Sri Lanka, Thailand, The Maldives, Vietnam",
    slug: "asia",
    image: require("../../Library/Images/destinations/asia/boats.jpg"),
    imagePath: "destinations/asia/boats.jpg",
    description:
      "Good transport connections and feeling secure are two of the most important requisites for traveling in Asian countries. This all comes down to knowing the right people on the ground and the loyalty that can only be achieved by their long-term working relationships with the specialist. Traveling to Asia is not only about visiting cultural sites but receiving the right advice to pace your time and not overload your itinerary. For example, India is such a huge and diverse country that it is advisable to savor fewer areas for longer rather than rush around with only a day or two in each place.",
    darkenImage: 0.2,
    informations: [
      {
        title: "STAY",
        location: "RIVERSOUL, CAMBODIA",
        content:
          "One block from the river in the center of Siem Reap, Cambodia lies a peaceful oasis. The hotel's charming and creative manager is also responsible for the very cool interior design, and witty quotes on all the literature. Loven and his team really go out of their way to help from arranging last-minute circus tickets to personalized tiffin boxes if you are out in the countryside for lunch.",
        imageUrl: require("../../Library/Images/destinations/asia/crab.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
      {
        title: "ART",
        location: "SUZANNE LECHT, VIETNAM",
        content:
          "Vietnam's contemporary art scene cannot be explored without coming across Suzanne Lecht’s name. Arriving from America via Hong Kong over 20 years ago this remarkable lady decided to acquaint herself with a small group of young artists whom she then began to promote and represent. The Gang of Five is now recognized internationally, and Suzanne continues to organize exhibitions in her adopted home of Hanoi.",
        imageUrl: require("../../Library/Images/destinations/asia/woman.jpg"),
        frameColor: colors.red,
        orientFrame: ["bottom", "left"],
        inverted: false,
      },
      {
        title: "FLOAT",
        location: "SUKOON, KASHMIR",
        content:
          "The houseboat tradition in Kashmir was begun by the British as a ploy to avoid Indian regulations about foreigners owning land. Today, the banks of Dal Lake are cheek by jowl with houseboats and the one to stay on is Sukoon. It has the most serene setting close to the floating markets and the Mughal gardens. The nine suites are large enough to make you question whether you are in fact on a boat, and the chef's coconut/ginger lake fish is utterly delicious. ",
        imageUrl: require("../../Library/Images/destinations/asia/house-boat.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
    ],
  },
  {
    name: "Central & South America",
    places:
      "Antarctica, Argentina, Belize, Bolivia, Brazil, Chile, Colombia, Costa Rica, Cuba, Ecuador, Guatemala, Mexico, Panama, Peru, The Galapagos, The Turks & Caicos Islands, Uruguay",
    slug: "central-and-south-america",
    image: require("../../Library/Images/destinations/south-america/sky.jpg"),
    imagePath: "destinations/south-america/sky.jpg",
    description:
      "As part of the world I have frequented the most I am always excited to share my knowledge of its vast range of possibilities. For travelers from North America it is an ideal year-round vacation spot as much closer than many realize with a number of direct flights from US hubs, and no jet-lag. It is also a region where two countries often combine well, such as Peru with Bolivia and Argentina with Uruguay. And now there are an exciting number of independent, design-worthy lodges in the more extreme and stunningly beautiful areas so you don’t have to rough it. Whether traveling as a family or as a couple the diversity of activities is abundant, and even a 7 day trip can include a large range of different experiences.",
    darkenImage: 0.25,
    informations: [
      {
        title: "FROMAGERIE",
        location: "Vira,Vira, Chile",
        content:
          "Cheese is not highly rated in Chile but at this beautiful private lodge in the heart of the lake and volcano district, the owner decided to address this issue. Alongside their organic farm Michael built a fully-fledged fromagerie, imported cultures from Europe, and employed a full-time cheese-maker who is supervised by annual visits from a Swiss expert. The result is shavings of Parmigiano served on wild boar risotto.",
        imageUrl: require("../../Library/Images/destinations/south-america/cheese.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
      {
        title: "WINERY",
        location: "Narbona, Uruguay",
        content:
          "Rather like Sleeping Beauty, the Narbona vineyard was brought back to life after 30 years of abandonment. The main house and neighboring grocery store have been converted into a small hotel and appealing restaurant. Parrots nest in the surrounding trees, and a stunning state of the art building now houses the wine production side. A perfect break after a visit to the UNESCO city of Colonia.",
        imageUrl: require("../../Library/Images/destinations/south-america/fruit.jpg"),
        frameColor: colors.red,
        orientFrame: ["bottom", "left"],
        inverted: false,
      },
      {
        title: "ESTANCIA",
        location: "Cordoba, Argentina",
        content:
          "Cordoba is a region in the north west of Argentina primarily known for dove-shooting. There is also some amazing riding to be had, especially if you are looking for a really authentic estancia experience and a few days rest and relaxation. There are a couple of different but truly fantastic estancias to suit beginners and advanced riders.",
        imageUrl: require("../../Library/Images/destinations/south-america/horse.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
    ],
  },
  // {
  //   name: "Europe",
  //   places: "Denmark, Finland, Greece, Greenland, Iceland, Italy, Malta, Norway, Romania, Sweden",
  //   slug: "europe",
  //   image: require("../../Library/Images/destinations/europe/doorways.jpg"),
  //   imagePath: "destinations/europe/doorways.jpg",
  //   description:
  //     "Unlike other destinations, the 'full service' treatment with guides, transport and an itinerary is often not necessary for European travel. However, for Italy and the Nordic countries I work with two out-standing specialists who can make all the difference to your trip.",
  //   darkenImage: 0.2,
  //   informations: [
  //     {
  //       title: "SHOP",
  //       location: "IJO DESIGN, PUGLIA",
  //       content:
  //         "Puglia is my current favorite area in Italy. Ijo Design has two locations in Ostuni, and Lecce, the Baroque City. Traditional looms are used to weave their stunning creations and one is on display in the larger Lecce store. Both shops are worth a visit for women's fashion, accessories and home décor.",
  //       imageUrl: require("../../Library/Images/destinations/europe/woman.jpg"),
  //       frameColor: colors.green,
  //       orientFrame: ["bottom", "right"],
  //       inverted: true,
  //     },
  //     {
  //       title: "NORDIC LIFE",
  //       location: "29/2 AURLAND, NORWAY",
  //       content:
  //         "An inherited family farm on one of the largest fjords accessible by ferry from Bergen and train from Oslo. A perfect introduction to the Norwegian lifestyle: hiking of course, a visit to a picturesque goat farm, kayaking and a tour of Stave churches in the area. The small number of guests eat together in the evenings and compare their daily adventures.",
  //       imageUrl: require("../../Library/Images/destinations/europe/church.jpg"),
  //       frameColor: colors.red,
  //       orientFrame: ["bottom", "left"],
  //       inverted: false,
  //     },
  //     {
  //       title: "CULTURE",
  //       location: "ISLAND OF SKYROS, GREECE",
  //       content:
  //         "The most remote of the Sporades islands in northern Greece. The southern half of the island is a protected nature reserve where the eponymous Skyrian horses roam free, and the north is the cultural hub centered around the hilltop town of Chora with its Byzantine castle and 10th century monastery. Mythology and folklore are rich and reflected in the food, art and annual festivals.",
  //       imageUrl: require("../../Library/Images/destinations/europe/skyros.jpg"),
  //       frameColor: colors.green,
  //       orientFrame: ["bottom", "right"],
  //       inverted: true,
  //     },
  //   ],
  // },
  {
    name: "Middle East",
    places: "Egypt, Iran, Jordan, Oman, UAE",
    slug: "middle-east",
    image: require("../../Library/Images/destinations/middle-east/palace.png"),
    imagePath: "destinations/middle-east/palace.png",
    description:
      "This historically and culturally rich region needs constant observation and the specialists who cover this area are always best informed on matters of access and security.",
    darkenImage: 0.35,
    informations: [
      {
        title: "MUSEUM",
        location: "THE LOUVRE, ABU DHABI",
        content:
          "Opened in November, 2017 this 'universal museum' has come about through an agreement between France and the oil rich kingdom of the UAE, and promises to be more than a sleek building providing shade. The design by architect Jean Nouvel contains 55 low, white buildings divided into 23 galleries. The revolving displays will come mostly from French and American national collections with the intention of developing a cultural side to the country.",
        imageUrl: require("../../Library/Images/destinations/middle-east/jesus.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
    ],
  },
  {
    name: "USA & Canada",
    places: "",
    slug: "usa-and-canada",
    image: require("../../Library/Images/destinations/usa-and-canada/lighthouse.png"),
    imagePath: "destinations/usa-and-canada/lighthouse.png",
    description:
      "Similar to Europe, regular travel can easily be self-booked. If you want to expand the options, such as a different kind of US road-trip, seeing the Aurora Borealis from Canada or a Quebec gourmet trail I would be happy to provide an outline. Having lived in both countries for the past 30 years I have found a number of unique places. When it comes to booking flights and hotels I can connect you to the right specialist.",
    darkenImage: 0.2,
    informations: [
      {
        title: "ROAD TRIPS",
        location: "ALL ROADS NORTH",
        content:
          "For the ultimate American road trip with every detail outlined look no further than this Los Angeles-based company. Families have raved about West coast trips paced with children in mind and navigating National Parks to avoid the crowds.",
        imageUrl: require("../../Library/Images/destinations/usa-and-canada/all-roads-north.jpg"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
      {
        title: "WELLNESS",
        location: "LE MONASTÈRE DES AUGUSTINES, QUEBEC",
        content:
          "The nuns’ legacy of healing has been transferred to visitors looking for rest and a healthy retreat in this stunning conversion of a 350 year-old monastery in the heart of the old city. Yoga, meditation walks, an extensive museum and a first class restaurant are all part of the experience. There is also the option to stay in an updated nun’s bedroom.",
        imageUrl: require("../../Library/Images/destinations/usa-and-canada/monastery.jpg"),
        frameColor: colors.red,
        orientFrame: ["bottom", "left"],
        inverted: false,
      },
      {
        title: "OUTPOST",
        location: "FOGO ISLAND INN, NEWFOUNDLAND",
        content:
          "I visited Fogo, an island off the coast of Newfoundland, in the opening year of the Inn. It remains my favorite place and the only hotel I have actually sat in the chair in my room – the view was so staggering. Vodka infused with spruce and spiked with ice from a passing iceberg, jolly fishermen to take you to the outlying islands and the pure heartiness of the locals all captivated me. A bit of a hike to get there but worth the effort for something extraordinary.",
        imageUrl: require("../../Library/Images/destinations/usa-and-canada/fogo.png"),
        frameColor: colors.green,
        orientFrame: ["bottom", "right"],
        inverted: true,
      },
    ],
  },
]
